import React from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import moment from 'moment'
import {TFormAllValues, TFormMemberPolicy} from '../../../../policies/policiesTypes'
import {FormikErrors, FormikTouched} from 'formik'
import {GENDER_OPTIONS, RELATIONSHIP_OPTIONS} from '../../../../../helpers/consts'
import {DateInput} from 'app/tfi/components/DateInput'
import {PhoneInput} from 'app/tfi/components/PhoneInput'
import {copyToClipboard} from '../../../../../../../utils/clipboardUtils'

interface PersonalInformationProps {
  membernum: number
  valuesMember: TFormMemberPolicy
  errors: FormikErrors<TFormMemberPolicy>
  touched: FormikTouched<TFormMemberPolicy>
  allValues: TFormAllValues
  isHolder: boolean
  handleChange: (field: string, value: string | boolean) => void
  handleBlur: (field: string) => void
  disableEmail?: boolean
}

export const PersonalInformation: React.FC<PersonalInformationProps> = ({
  membernum,
  valuesMember,
  errors,
  touched,
  allValues,
  isHolder,
  handleChange,
  handleBlur,
  disableEmail = false,
}) => {
  return (
    <div>
      <Row>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Is this member an applicant?</Form.Label>
            <Form.Select
              name='applicant'
              value={valuesMember.applicant ? 'yes' : 'no'}
              onChange={(e) => {
                handleChange('applicant', e.target.value === 'yes')
              }}
            >
              <option value='yes'>Yes</option>
              <option value='no'>No</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Preferred language</Form.Label>
            <Form.Select
              value={valuesMember.preferredLenguage ?? ''}
              name='preferredLenguage'
              onChange={(e) => {
                handleChange('preferredLenguage', e.target.value)
              }}
            >
              <option value='english'>English</option>
              <option value='spanish'>Spanish</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group>
            <Form.Label className='d-flex align-items-center gap-2'>
              <i
                className='bi bi-files'
                onClick={() => copyToClipboard(valuesMember.firstName, 'First Name')}
                title='Copy First Name'
                style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
              ></i>
              <span>First name <small className='text-danger'>{errors && errors.firstName}</small></span>
            </Form.Label>
            <Form.Control
              name='firstName'
              placeholder='Enter first name'
              id='firstName'
              required
              value={valuesMember.firstName ?? ''}
              onBlur={() => handleBlur('firstName')}
              onChange={(e) => {
                handleChange('firstName', e.target.value)
              }}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label htmlFor='middleName' className='d-flex align-items-center gap-2'>
              <i
                className='bi bi-files'
                onClick={() => copyToClipboard(valuesMember.middleName, 'Middle Name')}
                title='Copy Middle Name'
                style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
              ></i>
              <span>Middle name</span>
            </Form.Label>
            <Form.Control
              name='middleName'
              id='middleName'
              value={valuesMember.middleName ?? ''}
              onChange={(e) => {
                handleChange('middleName', e.target.value)
              }}
              placeholder='(optional)'
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group>
            <Form.Label htmlFor='lastName' className='d-flex align-items-center gap-2'>
              <i
                className='bi bi-files'
                onClick={() => copyToClipboard(valuesMember.lastName, 'Last Name')}
                title='Copy Last Name'
                style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
              ></i>
              <span>Last Name <small className='text-danger'>{errors.lastName}</small></span>
            </Form.Label>
            <Form.Control
              name='lastName'
              placeholder='Enter last name'
              value={valuesMember.lastName ?? ''}
              onChange={(e) => {
                handleChange('lastName', e.target.value)
              }}
              onBlur={() => handleBlur('lastName')}
              id='lastName'
              className='form-control '
              required
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label htmlFor='secondLastName' className='d-flex align-items-center gap-2'>
              <i
                className='bi bi-files'
                onClick={() => copyToClipboard(valuesMember.secondLastName, 'Second Last Name')}
                title='Copy Second Last Name'
                style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
              ></i>
              <span>Second last name</span>
            </Form.Label>
            <Form.Control
              name='secondLastName'
              value={valuesMember.secondLastName ?? ''}
              onChange={(e) => {
                handleChange('secondLastName', e.target.value)
              }}
              id='secondLastName'
              placeholder='(optional)'
            />
          </Form.Group>
        </Col>
      </Row>
      {!isHolder && (
        <Row className='member-rol'>
          <Col md={6}>
            <Form.Group>
              <Form.Label htmlFor='rol'>Rol</Form.Label>
              <Form.Select
                value={valuesMember.rol ?? ''}
                name='rol'
                id='rol'
                onChange={(e) => {
                  handleChange('rol', e.target.value)
                }}
              >
                {/* <option value=''>Select one</option> */}
                {/* <option value='HOLDER'>Holder</option> */}
                <option value='FAMILY'>Family</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label htmlFor='rol'>Relationship</Form.Label>
              <Form.Select
                value={valuesMember.relationship ?? ''}
                name='relationship'
                id='relationship'
                onChange={(e) => {
                  handleChange('relationship', e.target.value)
                }}
              >
                {/* <option value=''>Select one</option> */}
                {/* <option value='HOLDER'>Holder</option> */}
                {RELATIONSHIP_OPTIONS.map(({value, label}) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
      )}
      <Row>
        <Col md={6}>
          <Form.Group>
            <Form.Label className='label-date-of-birth-age d-flex justify-content-between align-items-center'>
              <span className='d-flex align-items-center gap-2'>
                <i
                  className='bi bi-files'
                  onClick={() => {
                    const dobStr = valuesMember.dateBirth ? moment(valuesMember.dateBirth).format('MM/DD/YYYY') : ''
                    copyToClipboard(dobStr, 'Date of Birth')
                  }}
                  title='Copy Date of Birth'
                  style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                ></i>
                <span>Date of Birth <small className='text-danger'>{errors.dateBirth}</small></span>
              </span>
              <span className='age'>
                {valuesMember.dateBirth
                  ? `Age: ${moment().diff(moment(valuesMember.dateBirth), 'years')}`
                  : 'Age: -'}
              </span>
            </Form.Label>
            <DateInput
              id="dateBirth"
              name="dateBirth"
              label=""
              value={valuesMember.dateBirth}
              error={errors.dateBirth}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label htmlFor='gender'>
              Gender <small className='text-danger'>{errors.gender}</small>
            </Form.Label>
            <Form.Select
              name='gender'
              id='gender'
              value={valuesMember.gender ?? ''}
              onBlur={() => handleBlur('gender')}
              onChange={(e) => {
                handleChange('gender', e.target.value)
              }}
            >
              <option value=''>Select one</option>
              {GENDER_OPTIONS.map(({value, label}) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group>
            <Form.Label htmlFor='emailAddress' className='d-flex align-items-center gap-2'>
              <i
                className='bi bi-files'
                onClick={() => copyToClipboard(valuesMember.emailAddress, 'Email')}
                title='Copy Email'
                style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
              ></i>
              <span>
                Email <small className='text-danger'>{errors.emailAddress}</small>
              </span>
            </Form.Label>
            <Form.Control
              type='email'
              name='emailAddress'
              value={valuesMember.emailAddress ?? ''}
              onBlur={() => handleBlur('emailAddress')}
              onChange={(e) => {
                handleChange('emailAddress', e.target.value)
              }}
              id='emailAddress'
              autoComplete='off'
              disabled={disableEmail}
              readOnly={disableEmail}
            />
            {disableEmail && (
              <small className='text-muted'>
                Advisors cannot edit the email of a completed policy.
              </small>
            )}
          </Form.Group>
        </Col>
        <Col md={6}>
          <PhoneInput
            id="phone"
            name="phone"
            label={
              <span className='d-flex align-items-center gap-2'>
                <i
                  className='bi bi-files'
                  onClick={() => copyToClipboard(valuesMember.phone, 'Phone')}
                  title='Copy Phone'
                  style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                ></i>
                <span>
                  Phone <small className='text-danger'>{errors.phone}</small>
                </span>
              </span>
            }
            value={valuesMember.phone}
            error={errors.phone}
            touched={touched.phone}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <Form.Check
            label='Tobacco user'
            type='switch'
            name={
              membernum === 0 ? 'holder.usesTobacco' : `policyMembers[${membernum - 1}].usesTobacco`
            }
            id={`usesTobacco_${membernum}`}
            checked={
              typeof valuesMember.usesTobacco === 'string'
                ? valuesMember.usesTobacco === 'true'
                : valuesMember.usesTobacco
            }
            onChange={(e) => {
              console.log(String(e.target.checked))
              handleChange('usesTobacco', String(e.target.checked))
            }}
          />
        </Col>
        <Col md={3}>
          <Form.Check
            label='Pregnant'
            type='switch'
            name={
              membernum === 0 ? 'holder.isPregnant' : `policyMembers[${membernum - 1}].isPregnant`
            }
            id={`isPregnant_${membernum}`}
            checked={
              typeof valuesMember.isPregnant === 'string'
                ? valuesMember.isPregnant === 'true'
                : valuesMember.isPregnant
            }
            onChange={(e) => {
              handleChange('isPregnant', String(e.target.checked))
            }}
          />
        </Col>
        <Col md={6}>
          <Form.Check
            label='Eligible for health coverage through a job, Medicare, Medicaid, or CHIP'
            type='switch'
            name={
              membernum === 0 ? 'holder.hasMec' : `policyMembers[${membernum - 1}].hasMec`
            }
            id={`hasMec_${membernum}`}
            checked={
              typeof valuesMember.hasMec === 'string'
                ? valuesMember.hasMec === 'true'
                : valuesMember.hasMec
            }
            onChange={(e) => {
              handleChange('hasMec', String(e.target.checked))
            }}
          />
        </Col>
      </Row>
    </div>
  )
}
